import script from "./EstimatedWorkHoursModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EstimatedWorkHoursModal.vue?vue&type=script&setup=true&lang=js"

import "./EstimatedWorkHoursModal.vue?vue&type=style&index=0&id=7700b007&lang=css"

const __exports__ = script;

export default __exports__